/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _ExportInputs */

const en__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const fr__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter`)
};

const de__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const it__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportare`)
};

const ru__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт`)
};

const es__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

const zh_cn2__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口`)
};

const ja__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸出`)
};

const hi__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात`)
};

const pt_pt2__export = /** @type {(inputs: _ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
const _export = /** @type {((inputs?: _ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr__export(inputs)
	if (locale === "de") return de__export(inputs)
	if (locale === "it") return it__export(inputs)
	if (locale === "ru") return ru__export(inputs)
	if (locale === "es") return es__export(inputs)
	if (locale === "zh-CN") return zh_cn2__export(inputs)
	if (locale === "ja") return ja__export(inputs)
	if (locale === "hi") return hi__export(inputs)
	if (locale === "pt-PT") return pt_pt2__export(inputs)
	return en__export(inputs)
});
export { _export as "export" }